var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchYearName',{attrs:{"title":'Comissões de Festa',"minYear":1981,"directory":'comissoes_festa'}})}
var staticRenderFns = []

export { render, staticRenderFns }